// Janela "Marcar envio" da tela Envio de Contas: o que a equipe registra no Quality sobre a prorrogação
// (vale mesmo sem marcação no IW). Cada alteração guarda o "antes" — aparece no histórico abaixo do formulário.
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { P, fmtMes, fmtData, fmtDataHora, postarProrrogacoes, Autorizacao } from './comum';

export const CANAIS = { email: 'E-mail', portal: 'Portal da operadora', drive: 'Drive / link', outro: 'Outro' };
export const RESPOSTAS = { aguardando: 'Aguardando resposta', aprovado: 'Aprovada (autorizada)', devolutiva: 'Devolutiva de ajuste', negado: 'Negada' };
const hoje = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Sao_Paulo' });

export default function MarcarEnvio({ linha, aoFechar, aoSalvar }) {
  const m = linha.marcacao || {};
  const [f, setF] = useState({
    enviado: m.enviado ?? false,
    enviadoEm: m.enviadoEm || hoje(),
    canal: m.canal || '',
    nrSolicitacao: m.nrSolicitacao || linha.nrSolIW || '',
    resposta: m.resposta || 'aguardando',
    respostaEm: m.respostaEm || '',
    senha: m.senha || '',
    observacao: m.observacao || '',
  });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const muda = (k, v) => setF(x => ({ ...x, [k]: v }));

  const salvar = async () => {
    setSalvando(true); setErro('');
    try {
      await postarProrrogacoes('marcar', {
        numIW: linha.numIW, periodo: linha.periodo, paciente: linha.paciente, operadora: linha.operadora, orcamentoId: linha.orcamentoId,
        ...f, respostaEm: f.resposta !== 'aguardando' ? (f.respostaEm || hoje()) : '',
      });
      aoSalvar();
    } catch (e) { setErro(e.message); setSalvando(false); }
  };

  const campo = { display: 'flex', flexDirection: 'column', gap: 4, fontSize: '0.78rem', color: P.muted, fontWeight: 600 };
  const input = { padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: '0.85rem', color: P.text, background: P.white };
  const historico = m.historico || [];

  return (
    <div onClick={aoFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} role="dialog" aria-label="Marcar envio da prorrogação"
        style={{ background: P.white, borderRadius: 16, width: 'min(620px, 100%)', maxHeight: '92vh', overflowY: 'auto', padding: 20, boxShadow: '0 20px 50px rgba(15,23,42,.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
          <div>
            <div style={{ fontSize: '1.1rem', fontWeight: 800, color: P.text }}>📤 Prorrogação de {fmtMes(linha.periodo)}</div>
            <div style={{ fontSize: '0.82rem', color: P.text, fontWeight: 700, marginTop: 2 }}>{linha.paciente}</div>
            <div style={{ fontSize: '0.75rem', color: P.muted }}>{linha.operadora} · IW {linha.numIW}{linha.orcamentoId ? ` · orç. ${linha.orcamentoId}` : ''}</div>
          </div>
          <button onClick={aoFechar} aria-label="Fechar" style={{ border: 'none', background: 'none', cursor: 'pointer', color: P.muted, alignSelf: 'flex-start' }}><X size={20} /></button>
        </div>

        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '12px 0', fontSize: '0.75rem', color: P.muted, alignItems: 'center' }}>
          No IW: aprovação interna <Autorizacao codigo={linha.interna} /> · operadora <Autorizacao codigo={linha.ext} />
          {linha.envio?.envioIW && <span style={{ color: '#166534', fontWeight: 700 }}>· marcado como enviado no IW</span>}
          {linha.statusEnvioIWTexto && <span>· status no IW: <strong style={{ color: P.text }}>{linha.statusEnvioIWTexto}</strong></span>}
        </div>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.9rem', fontWeight: 700, color: P.text, cursor: 'pointer', marginBottom: 10 }}>
          <input type="checkbox" checked={f.enviado} onChange={e => muda('enviado', e.target.checked)} style={{ width: 18, height: 18 }} />
          Prorrogação enviada à operadora
        </label>
        {f.enviado && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 10, marginBottom: 12 }}>
            <label style={campo}>Data do envio<input type="date" value={f.enviadoEm} onChange={e => muda('enviadoEm', e.target.value)} style={input} /></label>
            <label style={campo}>Por onde
              <select value={f.canal} onChange={e => muda('canal', e.target.value)} style={input}>
                <option value="">—</option>
                {Object.entries(CANAIS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            </label>
          </div>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 10, marginBottom: 12 }}>
          <label style={campo}>Nº da solicitação<input value={f.nrSolicitacao} onChange={e => muda('nrSolicitacao', e.target.value)} style={input} placeholder="ex.: PAD0112399" /></label>
          <label style={campo}>Resposta da operadora
            <select value={f.resposta} onChange={e => muda('resposta', e.target.value)} style={input}>
              {Object.entries(RESPOSTAS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
          </label>
          {f.resposta !== 'aguardando' && <label style={campo}>Data da resposta<input type="date" value={f.respostaEm || hoje()} onChange={e => muda('respostaEm', e.target.value)} style={input} /></label>}
          <label style={campo}>Senha / autorização<input value={f.senha} onChange={e => muda('senha', e.target.value)} style={input} /></label>
        </div>
        <label style={campo}>Observação
          <textarea value={f.observacao} onChange={e => muda('observacao', e.target.value)} rows={3} style={{ ...input, resize: 'vertical', fontFamily: 'inherit' }} placeholder="ex.: operadora pediu relatório da fono" />
        </label>
        {linha.obsIW && <div style={{ fontSize: '0.75rem', color: '#92400e', marginTop: 6 }}>💬 Obs no IW: {linha.obsIW}</div>}

        {erro && <div style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '8px 10px', fontSize: '0.8rem', marginTop: 10 }}>{erro}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 14 }}>
          <button onClick={aoFechar} style={{ border: `1px solid ${P.border}`, background: P.white, borderRadius: 8, padding: '8px 14px', cursor: 'pointer' }}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={{ border: 'none', background: P.primary, color: '#fff', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontWeight: 700 }}>{salvando ? 'Salvando…' : 'Salvar'}</button>
        </div>

        {(m.emails || []).length > 0 && (
          <div style={{ marginTop: 16, borderTop: `1px solid ${P.border}`, paddingTop: 10 }}>
            <div style={{ fontSize: '0.78rem', fontWeight: 800, color: P.text, marginBottom: 6 }}>📧 E-mails que o robô achou (caixa prorrogacoes@)</div>
            {m.emails.map((e, i) => (
              <div key={i} style={{ fontSize: '0.74rem', color: P.muted, padding: '4px 0', borderTop: '1px dashed #f1f5f9' }}>
                <strong style={{ color: P.text }}>{fmtDataHora(e.em)} · {e.tipo === 'envio' ? 'Envio' : 'Resposta da operadora'}</strong>
                {e.classificacao && ` · leitura: ${{ aprovado: 'aprovada', negado: 'negada', devolutiva: 'devolutiva', recebido: 'recebimento', conferir: 'não deu para ler — conferir' }[e.classificacao] || e.classificacao}`}
                <div>{e.assunto} — {e.de}</div>
              </div>
            ))}
          </div>
        )}

        {(m.atualizadoEm || historico.length > 0) && (
          <div style={{ marginTop: 16, borderTop: `1px solid ${P.border}`, paddingTop: 10 }}>
            <div style={{ fontSize: '0.78rem', fontWeight: 800, color: P.text, marginBottom: 6 }}>🕘 Histórico</div>
            {m.atualizadoEm && <div style={{ fontSize: '0.74rem', color: P.muted, marginBottom: 4 }}>Última alteração: {fmtDataHora(m.atualizadoEm)} · {m.atualizadoPor}{m.origem === 'email' ? ' (robô do e-mail)' : ''}</div>}
            {historico.map((h, i) => (
              <div key={i} style={{ fontSize: '0.74rem', color: P.muted, padding: '4px 0', borderTop: '1px dashed #f1f5f9' }}>
                <strong style={{ color: P.text }}>Antes de {fmtDataHora(historico[i - 1]?.salvoEm || m.atualizadoEm)}</strong>{h.por ? ` (salvo por ${h.por})` : ''}:{' '}
                {h.enviado ? `enviada em ${fmtData(h.enviadoEm)}${h.canal ? ` por ${CANAIS[h.canal] || h.canal}` : ''}` : 'não enviada'}
                {` · ${RESPOSTAS[h.resposta] || h.resposta}`}{h.nrSolicitacao ? ` · nº ${h.nrSolicitacao}` : ''}{h.senha ? ` · senha ${h.senha}` : ''}{h.observacao ? ` · "${h.observacao}"` : ''}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
